<template>
  <div class="primary--sidebar">
    <!-- Marca Interativa no topo do rail (igual .rail-brand do protótipo) -->
    <router-link :to="dashboardPath" class="rail-brand" title="Interativa">
      <svg viewBox="0 0 102.1 102.1" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M102,81.2c0-10.5,0.2-21,0-31.5c-0.3-13.1-5-24.6-14.2-34.1c-5.8-6-12.6-10.5-20.6-13C61.4,0.7,55.5-0.2,49.4,0C39,0.4,29.4,3.6,20.9,9.8C12.1,16.3,5.8,24.5,2.1,34.7c-2.2,6.1-2.3,12.4-2.1,18.8c0.7,20.9,15.1,39.3,34.6,46c5.9,2,11.9,2.9,18.1,2.6c-0.2-0.3-0.4-0.6-0.6-0.9c-5.5-7.3-11-14.6-16.5-21.9c-0.8-1.1-1.6-2.3-2.4-3.5c-0.7-0.9-1.6-1.8-2.5-2.6c-5.6-4.9-9.3-11-10.2-18.3c-0.7-6.1-0.1-12.2,3-17.9C29.5,27.4,37.8,21.8,49.1,21c5.3-0.4,10.5,0.5,15.3,3c10.2,5.4,16.1,13.8,16.6,25.3c0.5,10.6,0.1,21.2,0.2,31.8C88.2,81.1,95.1,81.2,102,81.2z"
        />
        <path
          fill="#01C6D8"
          d="M102,81.2c-6.9,0-13.9,0-20.8-0.1c-10.4,0-20.7,0.1-31.1,0c-10.9-0.1-16.9-5.8-17.2-5.9c0.8,1.2,2,2.9,2.8,4c5.5,7.3,11,14.6,16.5,21.9c0.2,0.3,0.4,0.6,0.6,0.9c12.7,0,25.4,0,38.2,0c3.6,0,7.3,0,11.1,0C102,95.1,102,88.1,102,81.2z"
        />
      </svg>
    </router-link>
    <nav ref="menuContainer" class="menu vertical">
      <primary-nav-item
        v-for="menuItem in visibleMenuItems"
        :key="menuItem.toState"
        :icon="menuItem.icon"
        :menu-key="menuItem.key"
        :name="menuItem.label"
        :to="menuItem.toState"
        :is-child-menu-active="menuItem.key === activeMenuItem"
      />

      <!-- Botão de expansão para itens ocultos -->
      <div
        v-if="hasHiddenItems"
        class="button clear button--only-icon menu-item expand-button"
        @mouseenter="showDropdownOnHover"
        @mouseleave="hideDropdownOnLeave"
      >
        <fluent-icon
          :icon="shouldShowDropdown ? 'dismiss' : 'add'"
          class="expand-icon"
          :class="{ 'is-open': shouldShowDropdown }"
        />
        <div class="item-count-badge">
          {{ hiddenItemsCount > 10 ? '10+' : hiddenItemsCount }}
        </div>

        <!-- Dropdown com itens ocultos posicionado relativo ao botão -->
        <div
          v-if="shouldShowDropdown"
          class="hidden-items-dropdown floating-dropdown"
          @mouseenter="keepDropdownOpen"
          @mouseleave="hideDropdownOnLeave"
        >
          <div
            v-for="(menuItem, index) in hiddenMenuItems"
            :key="menuItem.toState"
            class="hidden-item"
            :style="{ 'animation-delay': `${index * 0.1}s` }"
          >
            <router-link
              v-slot="{ href, isActive, navigate }"
              :to="menuItem.toState"
              custom
            >
              <a
                :href="href"
                class="button clear menu-item hidden-menu-item dropdown-item"
                :class="{
                  'is-active': isActive || menuItem.key === activeMenuItem,
                }"
                @click="navigate"
                @mouseenter="showTooltip($event, menuItem.label)"
                @mouseleave="hideTooltip"
              >
                <span class="hidden-item-ico">
                  <svg viewBox="0 0 24 24">
                    <path
                      v-for="(d, i) in railIconPaths(menuItem.key)"
                      :key="i"
                      :d="d"
                    />
                  </svg>
                </span>
                <span class="menu-label">{{
                  $t(`SIDEBAR.${menuItem.label}`)
                }}</span>
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </nav>

    <!-- Tooltip customizado -->
    <div v-if="tooltip.show" class="custom-tooltip" :style="tooltip.style">
      {{ tooltip.text }}
    </div>

    <div
      ref="manualIcon"
      v-tooltip.right="$t(`NOTIFICATIONS_PAGE.HELP`)"
      class="card-icon manual-icon"
      @click="opensPanelNewsAndTutorials"
    >
      <img
        class="faq"
        :src="require('../../../assets/images/open-book.png')"
        alt="faq"
      />
    </div>

    <news-and-tutorials-panel
      v-if="showPanelNewsAndTutorials"
      @close="closePanelNewsAndTutorials"
    />
    <modal-tour
      v-if="showTutorial"
      :close-tutorial="showTutorial"
      :steps="steps"
      @close="closeModalTutorial"
    />
  </div>
</template>
<script>
import PrimaryNavItem, { RAIL_ICONS } from './PrimaryNavItem';
import NewsAndTutorialsPanel from '../../../routes/dashboard/notifications/components/NewsAndTutorialsPanel.vue';
import wootConstants from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import ModalTour from '../../../routes/dashboard/notifications/components/ModalTour.vue';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import tutorialGif from '../../../assets/tutorials/guiamain.gif';

export default {
  components: {
    PrimaryNavItem,
    NewsAndTutorialsPanel,
    ModalTour,
  },
  mixins: [uiSettingsMixin],
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      helpDocsURL: wootConstants.DOCS_URL,
      showOptionsMenu: false,
      showPanelNewsAndTutorials: false,
      showTutorial: false,
      showHiddenItems: false,
      maxVisibleItems: 10, // Valor inicial alto para mostrar todos os itens até o cálculo ser feito
      isExpanded: false,
      isHovering: false,
      hoverTimeout: null,
      tooltip: {
        show: false,
        text: '',
        style: {},
      },
    };
  },

  computed: {
    dashboardPath() {
      return frontendURL(`accounts/${this.accountId}/dashboard`);
    },
    steps() {
      const stepsApp = [
        {
          preview: tutorialGif,
          title: this.$t('GUIDE.TUTORIAL.GUIDE_INTERATIVA.TITLE'),
          description: this.$t('GUIDE.TUTORIAL.GUIDE_INTERATIVA.LABEL'),
        },
      ];
      return stepsApp;
    },
    hasHiddenItems() {
      return this.menuItems.length > this.maxVisibleItems;
    },
    hiddenItemsCount() {
      return this.menuItems.length - this.maxVisibleItems;
    },
    visibleMenuItems() {
      if (this.isExpanded) {
        return this.menuItems;
      }
      return this.menuItems.slice(0, this.maxVisibleItems);
    },
    hiddenMenuItems() {
      return this.menuItems.slice(this.maxVisibleItems);
    },
    shouldShowDropdown() {
      return this.showHiddenItems || this.isHovering;
    },
  },
  watch: {
    menuItems: {
      handler() {
        this.calculateMaxVisibleItems();
      },
      immediate: true,
    },
  },
  mounted() {
    const showMainTutorial = this.uiSettings?.show_main_tutorial;
    if (showMainTutorial || showMainTutorial === undefined) {
      setTimeout(() => {
        this.showTutorial = true;
      }, 3000);
    }
    this.calculateMaxVisibleItems();
    window.addEventListener('resize', this.calculateMaxVisibleItems);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateMaxVisibleItems);
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  },
  methods: {
    frontendURL,
    // Mesmos ícones (SVG inline) do menu cheio, por chave — evita o asset
    // quebrado que o dropdown usava para o Fluxo de Campanhas.
    railIconPaths(key) {
      return RAIL_ICONS[key] || RAIL_ICONS.dashboard;
    },
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleAccountModal() {
      this.$emit('toggle-accounts');
    },
    toggleSupportChatWindow() {
      window.$chatwoot.toggle();
    },
    openNotificationPanel() {
      this.$emit('open-notification-panel');
    },

    opensPanelNewsAndTutorials() {
      this.showPanelNewsAndTutorials = true;
    },

    closePanelNewsAndTutorials() {
      this.showPanelNewsAndTutorials = false;
    },
    closeModalTutorial() {
      this.showTutorial = false;
    },
    calculateMaxVisibleItems() {
      this.$nextTick(() => {
        const menu = this.$refs.menuContainer;
        if (!menu) return;

        // Usa TODO o espaço real: do topo do menu até o ícone fixo do rodapé
        // (Guia Interativa) — sem reservar um valor fixo. Assim os ícones
        // preenchem a barra e só surge o "+" quando o próximo item chegaria a
        // menos de um "gap" (a mesma distância entre os ícones) do Guia.
        const navTop = menu.getBoundingClientRect().top;
        const manual = this.$refs.manualIcon;
        const manualTop = manual
          ? manual.getBoundingClientRect().top
          : window.innerHeight - 60;

        // Altura REAL do item (label torna ~54px) + o gap do .menu (0.4rem);
        // esse é o "passo" (pitch) de cada slot.
        const firstItem = menu.firstElementChild;
        const pitch =
          (firstItem ? firstItem.getBoundingClientRect().height : 54) + 4;

        const available = manualTop - navTop;

        // Nº de slots que cabem mantendo ao menos um gap acima do Guia.
        let maxItems = Math.floor(available / pitch);

        // Quando sobram itens ocultos, o botão "+" ocupa um slot próprio —
        // reserva 1 para ele não ficar em cima do ícone fixo do rodapé.
        if (this.menuItems.length > maxItems) {
          maxItems -= 1;
        }

        // Garantir que sempre mostre pelo menos 1 item
        this.maxVisibleItems = Math.max(
          1,
          Math.min(this.menuItems.length, maxItems)
        );
      });
    },
    showDropdownOnHover() {
      this.isHovering = true;
      this.showHiddenItems = true;
      // Limpar timeout se existir
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
    },
    hideDropdownOnLeave() {
      this.isHovering = false;
      // Usar setTimeout para dar tempo do mouse entrar no dropdown
      this.hoverTimeout = setTimeout(() => {
        if (!this.isHovering) {
          this.showHiddenItems = false;
          this.hideTooltip();
        }
      }, 150);
    },
    keepDropdownOpen() {
      this.isHovering = true;
      // Limpar timeout se existir
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
    },
    showTooltip(event, label) {
      const rect = event.target.getBoundingClientRect();
      this.tooltip = {
        show: true,
        text: this.$t(`SIDEBAR.${label}`),
        style: {
          position: 'fixed',
          left: `${rect.right + 12}px`,
          top: `${rect.top + rect.height / 2}px`,
          transform: 'translateY(-50%)',
          zIndex: 1001,
        },
      };
    },
    hideTooltip() {
      this.tooltip.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.primary--sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 7.6rem;
  box-sizing: border-box;
  height: 100%;
  flex-shrink: 0;
  padding: 0.6rem 0;
}

// Marca Interativa no topo do rail (igual .rail-brand do protótipo)
.rail-brand {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  margin: var(--space-one) auto var(--space-slab);
  flex: none;

  svg {
    width: 30px;
    height: 30px;
    display: block;
  }
}

.menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0;
  margin: 0;
}

.user-menu {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-end;
  margin-bottom: var(--space-normal);
}

.faq {
  height: 22px;
}
.manual-icon {
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 2rem;
  // Centraliza no rail (7.6rem de largura, ícone de 4rem): (7.6-4)/2 = 1.8rem.
  // Antes era 1.2rem e ficava deslocado ~6px à esquerda dos demais ícones.
  left: 1.8rem;
  background: var(--g-20) !important;
  border: 1px solid var(--g-20) !important;
}

.card-icon {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0.9rem;
  height: 40px;
  width: 40px;
  border: 1px solid transparent !important;
}

.card-icon:hover,
.card-icon:active {
  background: var(--g-20) !important;
  border: 1px solid var(--g-20) !important;
}

.expand-button {
  margin: var(--space-small) 0;
  transition: transform 0.2s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .expand-icon {
    transition: all 0.2s ease;
    color: white !important; // Cor branca por padrão

    &:hover,
    &.is-open {
      color: var(
        --g-20
      ) !important; // Cor azul no hover e quando aberto (mesma da bolinha)
    }
  }

  .item-count-badge {
    position: absolute;
    top: -8px;
    right: -8px;
    background: var(--g-20);
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    border: 2px solid var(--w-950);
    min-width: 20px;
    padding: 0 2px;
  }
}

.hidden-items-dropdown {
  position: absolute;
  left: 100%;
  bottom: 0;
  background: var(--w-950);
  border: none;
  border-radius: var(--border-radius-large);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 200px;
  padding: var(--space-small);
  max-height: 60vh;
  overflow-y: auto;
  margin-left: var(--space-small);

  &.floating-dropdown {
    animation: slideInFromBottom 0.3s ease-out;
  }

  .hidden-item {
    margin: var(--space-micro) 0;
    animation: fadeInUp 0.3s ease-out forwards;
    opacity: 0;
    transform: translateY(20px);

    .hidden-menu-item {
      margin: 0;
      width: 100%;
      justify-content: flex-start;
      padding: var(--space-small);
      display: flex;
      align-items: center;
      border-radius: var(--border-radius-large);
      border: none;
      color: var(--s-600);
      text-decoration: none;

      &:hover {
        background: var(--g-20) !important;
      }

      &.is-active {
        background: var(--g-20) !important;
      }

      .fi {
        margin-right: var(--space-small);
        font-size: 17px !important;
        color: var(--w-50);
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      // Ícone do item oculto: SVG inline (mesmos paths do menu cheio),
      // traço fino como o rail. Corrige o Fluxo de Campanhas que quebrava.
      .hidden-item-ico {
        margin-right: var(--space-small);
        width: 20px;
        height: 20px;
        display: grid;
        place-items: center;
        flex: none;

        svg {
          width: 20px;
          height: 20px;
          fill: none;
          stroke: var(--w-50);
          stroke-width: 2;
          stroke-linecap: round;
          stroke-linejoin: round;
        }
      }

      .menu-label {
        color: var(--w-50);
        font-size: 14px;
        white-space: nowrap;
      }
    }
  }
}

// Estilos para tooltips do dropdown
.hidden-items-dropdown {
  .dropdown-item {
    position: relative;
  }
}

// Tooltip customizado
.custom-tooltip {
  background: var(--w-950);
  color: var(--w-50);
  border: none;
  border-radius: var(--border-radius-small);
  padding: var(--space-micro) var(--space-small);
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  pointer-events: none;

  &:before {
    content: '';
    position: absolute;
    left: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid var(--w-950);
  }
}

@keyframes slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(20px) scaleY(0);
    transform-origin: bottom;
  }
  to {
    opacity: 1;
    transform: translateY(0) scaleY(1);
    transform-origin: bottom;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
